import React from "react"
import parse from "html-react-parser"
import Video from "../components/Video/Video"

function replaceIframes(domNode) {
  if (domNode.name === "iframe") {
    const src = domNode.attribs?.src || ""
    if (src.includes("youtube.com") || src.includes("youtu.be")) {
      return (
        <Video
          videoSrcURL={src}
          videoTitle={domNode.attribs?.title || ""}
        />
      )
    }
  }
}

export function parseContent(html) {
  return parse(html, { replace: replaceIframes })
}
